import { render } from "./VideoDetailsTagList.vue?vue&type=template&id=658d18a4&ts=true"
import script from "./VideoDetailsTagList.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsTagList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__